import styled from 'styled-components';

const StyledNameWithLink = styled.div`
  display: flex;
  flex-direction: column;

  a {
    align-items: center;
    display: flex;
    justify-content: center;

    svg {
      width: 12px;
      height: 12px;
      path {
        fill: ${props => props.theme.colors.neutral_6};
        transition: .2s ease;
      }
    }

    &:hover,&:active,&:focus {
      svg {
        path {
          fill: ${props => props.theme.colors.primary_5};
        }
      }
    }
  }
`;

export {
  StyledNameWithLink
};
